// import getSafe from "safe-get";
import getSafe from "../modules/commonModule/helpers/getSafe";

const getters = {
	getUserID: state => {
		return getSafe(() => state.user.id);
	},

	//coerced to number from a string value
	getPortID: state => {
		return +getSafe(()=>state.user.port.id);
	},
	getPorts: state => {
		return getSafe(() => state.ports);
	},

	getPortByID: state => {
		return id => {
			let list = state.ports.data.filter(
			  port => port.id === id
			);
			return list[0];
		  };
	},

	isLoggedIn: state => {
		return getSafe(() => state.accessToken !== null);
	},

	getUserRole: state => {
		return getSafe(()=>state.userRoles[0])
	},

	getUserDetails: state => {
		return ({
			full_name: state.user.full_name,
			user_name: state.user.user_name,
			user_email: state.user.email,
			user_port: state.user.port
		})
	}
};

export default getters;
